import { CountDown } from 'src/components/DateAndTime/CountDown';
import React from 'react';

export const getEndMessage = (now, endDate) => {
  if(now.isAfter(endDate)) {
    return (<>Ended: {endDate.format('M/D hh:mma z')}</>);
  }
  if(endDate.diff(now, 'h') < 24) {
    return (<CountDown preText={'Ends in: '} endTime={endDate}/>);
  }
  return (<>Ends: {endDate.format('M/D hh:mma z')}</>);
};
